import React from "react";
import styled from "styled-components";
import { AutoComplete } from "antd";
import { debounce } from "../utils.js";

const SlayerTaskSearch = ({ slayerTasks, onSearch, onSelect }) => {
  const debouncedOnSearch = debounce((value) => {
    onSearch(value);
  }, 300);

  const taskNames = slayerTasks.map((task) => ({
    value: task.monster_name.name,
  }));

  return (
    <SearchContainer>
      <AutoComplete
        style={{ width: 280 }}
        placeholder="Input Slayer Task..."
        allowClear
        backfill={true}
        options={taskNames.length ? taskNames : []}
        onSelect={onSelect}
        onSearch={debouncedOnSearch}
        onClear={() => onSelect("")}
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
      />
    </SearchContainer>
  );
};

export default SlayerTaskSearch;

const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;
